var FcCompanyInputModule = /** @class */ (function () {
    function FcCompanyInputModule() {
    }
    return FcCompanyInputModule;
}());
export { FcCompanyInputModule };
